import React from 'react';

type Specialist = {
  name: string;
  iconUrl: string;
  onClick?: () => void; // tambahkan ini

};

const SpecialistCard = ({ name, iconUrl, onClick }: Specialist) => {
  return (
    <div
      onClick={onClick}
      className="flex flex-col items-center bg-white rounded-xl p-4 shadow hover:shadow-md transition cursor-pointer"
    >
      <div className="rounded-full p-4 w-20 h-20 flex items-center justify-center">
        <img src={iconUrl} alt={name} className="w-40 h-40 object-contain" />
      </div>
      <p className="text-sm text-gray-700 font-medium text-center">{name}</p>
    </div>
  );
};

export default SpecialistCard;
